module.exports = __webpack_public_path__ + "static/img/avatar_r_1.9fc9ccb5.png";